export default __webpack_public_path__ + "static/media/unreachable.4dfde61b.svg";